import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CommentIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.23077C4.26146 1.23077 1.23078 4.26146 1.23078 8C1.23078 9.6 1.42439 10.6253 2.23729 11.7076C2.35971 11.8705 2.39348 12.0835 2.32747 12.2764C2.13784 12.8304 1.85543 13.6571 1.6204 14.3454L1.57021 14.4925L2.10031 14.3508C2.95642 14.1218 3.87852 13.8751 4.14731 13.8026C4.30544 13.7599 4.47406 13.782 4.61583 13.864C5.61087 14.4396 6.76603 14.7692 8 14.7692C11.7386 14.7692 14.7692 11.7385 14.7692 8C14.7692 4.26146 11.7386 1.23077 8 1.23077ZM0.615392 15.3846C0.0329834 15.1859 0.0329916 15.1859 0.0329916 15.1858L0.455662 13.9477C0.651371 13.3746 0.880023 12.7052 1.06063 12.1771C0.185361 10.8853 6.96956e-06 9.6128 6.96956e-06 8C6.96956e-06 3.58172 3.58173 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C6.63647 16 5.35115 15.6584 4.2265 15.0558C3.82269 15.1641 3.09865 15.3579 2.41821 15.5398L0.774801 15.979L0.615392 15.3846ZM0.615392 15.3846L0.774801 15.979C0.55533 16.0377 0.320836 15.9707 0.165742 15.8047C0.0106571 15.6388 -0.0403705 15.4009 0.0329916 15.1858L0.615392 15.3846Z"
        fill="currentColor"
      />
    </svg>
  )
})

CommentIcon.displayName = 'CommentIcon'
